import React from 'react';
export function BonusItems() {
  return null;
}